export default [
    {
      title: '首页',
      name: 'index'
    },
    {
        title: '反馈',
        name: 'component/handle'
    },
    {
      title: '进度处理',
      name: 'component/handleProcess'
  },
  ]


// WEBPACK FOOTER //
// ./src/route/feedBack.js